/* Nutrise cart cross-sell v1.22 */
if (!customElements.get('cart-cross-sell')) {
  customElements.define(
    'cart-cross-sell',
    class CartCrossSell extends HTMLElement {
      constructor() {
        super();
        this.addButton = this.querySelector('[data-cross-sell-add]');
        this.toggleButton = this.querySelector('[data-cross-sell-toggle]');
        this.optionsPanel = this.querySelector('[data-cross-sell-options]');
        this.optionButtons = [...this.querySelectorAll('[data-cross-sell-option]')];
        this.status = this.querySelector('[data-cross-sell-status]');
        this.isLoading = false;

        this.addButton?.addEventListener('click', (event) => this.addProduct(event, this.addButton));
        this.toggleButton?.addEventListener('click', this.toggleOptions.bind(this));
        this.optionButtons.forEach((button) => {
          button.addEventListener('click', (event) => this.addProduct(event, button));
        });
        this.addEventListener('keydown', this.onKeydown.bind(this));
      }

      toggleOptions(event) {
        event?.preventDefault();
        event?.stopPropagation();
        if (!this.toggleButton || !this.optionsPanel) return;

        const willOpen = this.optionsPanel.hidden;
        this.optionsPanel.hidden = !willOpen;
        this.toggleButton.setAttribute('aria-expanded', String(willOpen));
        this.classList.toggle('is-chooser-open', willOpen);

        if (willOpen) this.optionButtons[0]?.focus({ preventScroll: true });
      }

      onKeydown(event) {
        if (event.key !== 'Escape' || !this.optionsPanel || this.optionsPanel.hidden) return;
        this.optionsPanel.hidden = true;
        this.toggleButton?.setAttribute('aria-expanded', 'false');
        this.classList.remove('is-chooser-open');
        this.toggleButton?.focus({ preventScroll: true });
      }

      async addProduct(event, triggerButton) {
        event?.preventDefault();
        event?.stopPropagation();
        if (!triggerButton || this.isLoading) return;

        const variantId = Number.parseInt(triggerButton.dataset.variantId, 10);
        if (!Number.isInteger(variantId) || variantId <= 0) {
          this.showStatus('Bitte wähle ein verfügbares Produkt.');
          return;
        }

        const cartDrawer = document.querySelector('cart-drawer');
        const root = window.Shopify?.routes?.root || '/';
        const addUrl = `${root}cart/add.js`;
        const payload = {
          items: [{ id: variantId, quantity: 1 }],
        };

        if (cartDrawer?.getSectionsToRender) {
          payload.sections = cartDrawer.getSectionsToRender().map((section) => section.id);
          payload.sections_url = `${window.location.pathname}${window.location.search}`;
          cartDrawer.setActiveElement?.(triggerButton);
        }

        this.setLoading(true, triggerButton);
        this.showStatus('');

        try {
          const response = await fetch(addUrl, {
            method: 'POST',
            headers: {
              Accept: 'application/json',
              'Content-Type': 'application/json',
              'X-Requested-With': 'XMLHttpRequest',
            },
            body: JSON.stringify(payload),
          });
          const result = await response.json();

          if (!response.ok || result.status) {
            throw new Error(result.description || result.message || 'Das Produkt konnte nicht hinzugefügt werden.');
          }

          if (cartDrawer?.renderContents && result.sections) {
            cartDrawer.classList.remove('is-empty');
            cartDrawer.renderContents(result);
          } else {
            window.location.assign(window.routes?.cart_url || `${root}cart`);
          }

          document.dispatchEvent(new CustomEvent('cart:refresh'));
          document.dispatchEvent(new CustomEvent('cart:update'));
        } catch (error) {
          this.showStatus(error.message || 'Bitte versuche es erneut.');
          this.setLoading(false, triggerButton);
        }
      }

      setLoading(isLoading, activeButton) {
        this.isLoading = isLoading;

        [this.addButton, ...this.optionButtons].filter(Boolean).forEach((button) => {
          button.toggleAttribute('aria-disabled', isLoading);
          button.disabled = isLoading;
          button.classList.toggle('loading', isLoading && button === activeButton);
          button.querySelector('.loading__spinner')?.classList.toggle('hidden', !(isLoading && button === activeButton));
        });
      }

      showStatus(message) {
        if (this.status) this.status.textContent = message;
      }
    }
  );
}
